import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'kkis-app-webshop-info-section1',
    templateUrl: './info-section1.component.html',
    styleUrls: ['./info-section1.component.scss']
})
export class InfoSection1Component implements OnInit
{
    text = "";
    texts: string[] =
        ["Direkte Anbindung an Artikelstammdaten im KKIS System",
            "Einfaches Handling von Größen, Farben, Varianten von Artikeln",
            "Umfassende Sortier- und Filtermöglichkeiten für Artikel",
            "Zentrale Datenpflege und Steuerung der Darstellung (Bilder, Texte, ...)",
            "Automatisierte Bestandsführung durch Integration in KKIS System ",
            "Individuelle Anpassungs- und Gestaltungsmöglichkeiten für Shopoberfläche",
            "Einfachste Integration in bestehenden Webauftritt"]

    @Output()
    numberWarenkorbItems: EventEmitter<number> = new EventEmitter<number>();

    // Utils
    isLoading: boolean = true;

    constructor() { }

    ngOnInit(): void
    {


        this.isLoading = false;
        const random = Math.floor(Math.random() * this.texts.length);
        this.text = this.texts[random];
    }

    getNumberWarenkorbItems(event)
    {
        this.numberWarenkorbItems.emit(event);
    }
}
